module.exports = __webpack_public_path__ + "img/ns_erweima.b472ea13.jpg";